import { Outlet, useNavigate, useLocation } from "react-router-dom";
import { Monitor, History, Clock, Package, Wifi, WifiOff } from "lucide-react";
import { useScenario, usePendingCommands, useCurrentShift } from "../../store";
import { POS_OUTLETS } from "../../mocks/seed";
import { LegacyAppShell } from "./LegacyAppShell";

const RAIL_BASE = [
  { id: "terminal", icon: Monitor, label: "Terminal", path: "/pos" },
  { id: "history", icon: History, label: "History", path: "/pos/history" },
  { id: "shift", icon: Clock, label: "Shift", path: "/pos/close-shift" },
  { id: "offline", icon: Package, label: "Queue", path: "/pos/offline-queue" },
];

function getActiveSection(pathname: string) {
  if (pathname === "/pos" || pathname === "/pos/") return "terminal";
  if (pathname.startsWith("/pos/history")) return "history";
  if (pathname.startsWith("/pos/close-shift") || pathname.startsWith("/pos/open-shift")) return "shift";
  if (pathname.startsWith("/pos/offline")) return "offline";
  return "terminal";
}

export function PosLayout() {
  const navigate = useNavigate();
  const location = useLocation();
  const scenario = useScenario();
  const outlet = POS_OUTLETS.find((o) => o.id === scenario.outletId) ?? POS_OUTLETS[0];
  const shift = useCurrentShift(outlet?.id ?? "");
  const pending = usePendingCommands();
  const isOffline = scenario.networkState === "offline";
  const activeSection = getActiveSection(location.pathname);

  const items = RAIL_BASE.map((item) => (
    item.id === "offline" ? { ...item, badge: pending.length } : item
  ));

  return (
    <LegacyAppShell
      brand="POS"
      surface="POS"
      homePath="/pos"
      items={items}
      activeId={activeSection}
      title={outlet?.name ?? "Terminal"}
      identity={{ name: scenario.userName, subtitle: outlet?.name }}
      tools={(
        <>
          <span className={`pos-net-pill${isOffline ? " offline" : ""}`}>
            {isOffline ? <WifiOff size={14} /> : <Wifi size={14} />}
            {isOffline ? "Offline" : "Online"}
          </span>
          {shift ? (
            <button type="button" className="btn btn-sm btn-secondary" onClick={() => navigate("/pos/close-shift")}>
              Close shift
            </button>
          ) : (
            <button type="button" className="btn btn-sm btn-primary" onClick={() => navigate("/pos/open-shift")}>
              Open shift
            </button>
          )}
        </>
      )}
    >
      <Outlet />
    </LegacyAppShell>
  );
}
